<template>
  <div class="tourist-home">
    <!-- <div class="wrapper1" v-if="this.list.length === 0">
      <div class="bar-img1">
        <img src="../../assets/images/banner.png" alt="">
      </div>
      <div class="banner-bottom">
        <span>免费获取专业项目诊断报告</span>
        <span>赢咨询大礼</span>
        <span><img src="../../assets/images/fill.png" @click="open"/></span>
      </div>
    </div> -->
    <div class="swiper-container1">
      <div class="wrapper1">
        <swiper :options="swiperOption1" v-if="list.length>0">
          <!-- <swiper-slide>
            <div class="bar-img1">
              <img src="../../assets/images/banner.png" alt="">
            </div>
          </swiper-slide> -->
          <swiper-slide v-for="item in list" :key="$index">
            <div class="bar-img1">
              <template v-if="item.linkType===0">
                <img :src="item.picUrl" alt="">
              </template>
              <template v-else>
                <a :href="item.linkUrl" target="_blank" style="display: block;width: 100%;height: 100%">
                  <img :src="item.picUrl" alt="">
                </a>
              </template>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="swiper-pagination1"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="banner-bottom">
        <el-button @click="openInfo(1)">分公司合伙人咨询申请</el-button>
        <!-- <span>免费获取专业项目诊断报告</span>
        <span>赢咨询大礼</span>
        <span><img src="../../assets/images/fill.png" @click="open"/></span> -->
      </div>
    </div>
    <div class="marketing">
      <div class="mar">
        <img src="../../assets/images/5,268.png">
        <span class="mar-sp">家企业正在使用渠道无忧营销工具</span>
        <el-button type="primary" @click="openInfo(0)" class="mar-btn">马上体验</el-button>
      </div>
    </div>
    <div class="choose">
      <div class="choose-main">
        <div class="showLeft">选择我们的理由</div>
        <div class="showRight">WHY CHOOSE US</div>
        <div class="showLeft">连锁加盟标准化营销服务提供商</div>
        <div class="showRight">为连锁加盟企业赋能，为品牌加盟提速，为企业打造系统化的招商能力，<br/>
          完善的营销体系，定制化的品牌服务，根据企业需求，
          量身制定更懂您的营销推广计划、品牌全案策划、全网整合营销，为您省时省力。
        </div>
        <div class="showLeft">渠道无忧拥有招商智投，全网营销，品牌全案；三大完整营销体系，全面赋能连锁加盟企业，实现精准营销，全面解决连锁加盟行业，企业营销难，渠道拓展难。</div>
        <div>
          <el-button type="primary" @click="openInfo(0)"  class="choose-btn">马上体验</el-button>
        </div>
      </div>
    </div>
    <div class="my-product">
      <h1>我们提供的产品服务</h1>
      <div class="product-box">
        <ul class="tab-tilte">
          <li @click="cur = 0" :class="{ active:cur === 0 }">招商智投</li>
          <li @click="cur = 1" :class="{ active:cur === 1 }">品牌全案</li>
          <li @click="cur = 2" :class="{ active:cur === 2 }">全网营销</li>
        </ul>
        <div class="tab-content">
          <div v-show="cur === 0"><img src="../../assets/images/zs.png"/></div>
          <div v-show="cur === 1"><img src="../../assets/images/sq.png"/></div>
          <div v-show="cur === 2"><img src="../../assets/images/wj.png"/></div>
          <div class="tab-btn">
            <el-button type="primary" @click="openInfo(0)" class="btn">马上体验</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="laval">
      <el-carousel :interval="3000">
        <el-carousel-item>
          <img src="../../assets/images/obs.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/images/zx.png"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="logo-case">
      <div>
        <img src="../../assets/images/case.png"/>
        <el-button class="case-btn" @click="openInfo(0)">马上体验</el-button>
      </div>
    </div>
    <div class="swiper-container">
      <div class="wrapper">
        <swiper :options="swiperOption">
          <swiper-slide>
            <div class="per-img">
              <img src="../../assets/images/rongyu.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="per-img">
              <img src="../../assets/images/zz.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="per-img">
              <img src="../../assets/images/qy.png" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="per-img">
              <img src="../../assets/images/jx.png" alt="">
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <el-dialog
      class="dia-title"
      title="填写信息让您的专属客服帮您"
      :visible.sync="dialogVisible"
      center
      width="690px"
      height="460px">
      <div class="message">
        <el-form :model="form" ref="formModifyRow" :rules="rules">
          <el-form-item v-if="infoType === 0" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}" prop="enterpriseName">
            <el-input
              v-model="form.enterpriseName"
              placeholder="企业名称（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}">
            <el-input
              v-model="form.name"
              placeholder="姓名（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确'}]">
            <el-input
              v-model="form.telephone"
              placeholder="联系电话（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="message-btn"  @click="submitRow()">立即提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <Questionnaire ref="queForm"></Questionnaire>
  </div>
</template>

<script>
  import MsNav from '@/components/tourist/common/Nav'
  import MsFooter from '@/components/tourist/common/Footer'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import Api from '@/api/customer-good'
  import { FormArgument } from '@/models/customer-good'
  import Questionnaire from '@/components/tourist/common/Questionnaire'
  export default {
    name: 'ms-tourist-home',
    components: {
      swiper,
      swiperSlide,
      MsNav,
      MsFooter,
      Questionnaire
    },
    data () {
      return {
        list: [],
        http: '',
        infoType: 0,
        form: new FormArgument(),
        dialogVisible: false,
        cur: 0,
        message: [],
        swiperOption: {
          loop: true,
          speed: 900,
          notNextTick: true,
          autoplay: true,
          preloadImages: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          paginationClickable: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOption1: {
          loop: true,
          speed: 900,
          notNextTick: true,
          autoplay: true,
          preloadImages: false,
          pagination: {
            el: '.swiper-pagination1',
            clickable: true
          },
          paginationClickable: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    created () {
      setTimeout(() => { this.ani() }, 0)
      this.requestList()
    },
    methods: {
      openInfo (type) {
        this.infoType = type
        this.dialogVisible = true
      },
      requestList () {
        Api.viewpager(response => {
          let body = response.data
          let code = body.code
          if (code === '200') {
            this.list = body.data
          } else {
            this.list = []
          }
        })
      },
      submitRow () {
        this.$refs['formModifyRow'].validate((valid) => {
          if (valid) {
            // let name = this.form.name
            // let enter = this.form.enterpriseName
            // let phone = this.form.telephone
            // if (name !== '' && name !== undefined && enter !== '' && enter !== undefined && phone !== '' && phone !== undefined) {
            let form = this.form
            if (this.infoType === 0) {
              form.type = 1
            } else {
              form.type = 11
            }
            form.platform = 1
            if (this.$store.state.user.info !== null) {
              Api.createLogin({form: form}, response => {
                let status = response.status || 0
                let body = response.data || []
                if (status >= 200 && status <= 204) {
                  // 新数据加到数组开头
                  this.message.unshift(body)
                  this.$message.success('留言成功')
                } else {
                  this.$message.error(body.error || '留言失败')
                }
                // 关闭
                this.$refs['slideModifyRow'].close()
              })
              this.form = []
              this.dialogVisible = false
            } else {
              Api.create({form: form}, response => {
                let status = response.data.code
                let body = response.data
                if (status === '200') {
                  // 新数据加到数组开头
                  this.message.unshift(body.data)
                  this.$message.success('留言成功')
                } else {
                  this.$message.error(body.msg || '留言失败')
                }
                // 关闭
                this.$refs['slideModifyRow'].close()
              })
              this.form = []
              this.dialogVisible = false
            }
            // } else {
            //   this.$message.error('信息不能为空')
            // }
          } else {
            return false
          }
          this.form = []
        })
      },
      open () {
        this.$refs['queForm'].open()
      }
    }
  }
</script>

<style lang="scss">
  .swiper-container>.swiper-pagination> .swiper-pagination-bullet {
    background: #409EFF;
    margin: 0 10px;
  }
  .swiper-container>.swiper-pagination> .swiper-pagination-bullet-active {
    background: #333;
    margin: 0 5px;
  }
  .swiper-container1>.swiper-pagination1> .swiper-pagination-bullet {
    background: #fff;
    margin: 0 10px;
  }
  .swiper-container1>.swiper-pagination1> .swiper-pagination-bullet-active {
    background: #fff;
    margin: 0 5px;
  }
  .banner-bottom button{
    background: #085ecd;
    border-color:#085ecd;
    color:#fff;
  }
</style>
<style scoped="scoped" lang="scss">
  .tourist-home {
    width: 100%;
    overflow: hidden;
    .wrapper1{
      width: 100%;
      height: 550px;
      background: #1d3960;
      position: relative;
      max-width: 1920px;
      margin: 0 auto;
      .bar-img1 {
        width: 100%;
        height: 550px;
        img{
          width: 100%;
          height: 100%;
        } 
      }
      .banner-bottom {
        width: 100%;
        height: 90px;
        position: absolute;
        bottom: 0;
        z-index: 9;
        background: rgba(19, 45, 70, .6);
        line-height: 90px;
        text-align: center;
        font-size: 20px;
        color: white;
        // > span:nth-child(2) {
        //   margin: 0 12px;
        //   color: #23C6F5;
        // }
        // > span:nth-child(3) {
        //   position: absolute;
        //   top: 15px;
        //   &:hover {
        //     cursor: pointer;
        //   }
        // }
      }
    }
    .swiper-container1 {
      width: 100%;
      height: 550px;
      background: #1d3960;
      position: relative;
      .swiper-pagination1{
        position: absolute;
        bottom: 100px;
        width: 100%;
        margin: auto;
        z-index: 10;
        text-align:center;
      }
      .bar-img1 {
        width: 100%;
        height: 550px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .banner-bottom {
        width: 100%;
        height: 90px;
        position: absolute;
        bottom: 0;
        z-index: 9;
        background: rgba(19, 45, 70, .6);
        line-height: 90px;
        text-align: center;
        font-size: 20px;
        color: white;
        > span:nth-child(2) {
          margin: 0 12px;
          color: #23C6F5;
        }
        > span:nth-child(3) {
          position: absolute;
          top: 15px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .marketing {
      width: 100%;
      height: 164px;
      background: url("../../assets/images/background_1.png") no-repeat;
      position: relative;
      >.mar{
        width: 620px;
        height: 170px;
        position: absolute;
        top: 135px;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        >img{
          float: left;
          vertical-align:top;
          display: block;
        }
        >.mar-sp{
          color: #333;
          font-size: 26px;
          margin: 0 20px;
          font-weight: bold;
          float: left;
          display: block;
        }
        >.mar-btn{
          float: left;
          background: #085ECC;
          display: block;
          margin-top: -5px;
          outline: none;
          border: none;
          &:hover{
            background: #4a98ff;
            transition-duration: 0.5s;
          }
        }
      }
    }
    .choose {
      width: 100%;
      height: 694px;
      background: url("../../assets/images/background_2.png") no-repeat center;
      position: relative;
      .choose-main {
        position: absolute;
        left: 380px;
        top: 85px;
        > div:nth-child(1) {
          font-size: 46px;
          font-weight: bold;
          color: white;
        }
        > div:nth-child(2) {
          font-size: 56px;
          font-weight: 100;
          color: white;
          margin: 20px 0;
        }
        > div:nth-child(3) {
          font-size: 24px;
          font-weight: bold;
          color: white;
        }
        > div:nth-child(4) {
          width: 580px;
          height: 130px;
          font-size: 18px;
          color: white;
          margin-top: 26px;
        }
        > div:nth-child(5) {
          width: 580px;
          height: 130px;
          font-size: 18px;
          color: white;
        }
        > div:nth-child(6) {
          position: absolute;
          bottom: -20px;
          >.choose-btn{
            background: #085ECC;
            outline: none;
            border: none;
            &:hover{
              background: #4a98ff;
              transition-duration: 0.5s;
            }
          }
        }
      }
    }
    .my-product {
      width: 100%;
      height: 764px;
      padding-top: 46px;
      box-sizing: border-box;
      > h1 {
        padding: 0;
        margin: 0;
        text-align: center;
      }
      .product-box {
        width: 1300px;
        height: 518px;
        margin: 44px auto;
        position: relative;
        .tab-tilte {
          width: 1300px;
          margin-left: 380px;
          padding: 0;
          list-style: none;
          .active {
            background: linear-gradient(to right top, #FFF5D2, #FDCB84);
            color: #333;
            font-weight: bold;
          }
          > li {
            float: left;
            width: 180px;
            height: 50px;
            background: #085ECC;
            line-height: 50px;
            text-align: center;
            margin-bottom: 38px;
            color: white;
            &:hover {
              cursor: pointer;
            }
          }
          li:nth-child(1) {
            border-radius: 50px 0 0 50px;
          }
          li:nth-child(2) {
            border-left: 1px solid #2c80e5;
            border-right: 1px solid #2c80e5;
          }
          li:nth-child(3) {
            border-radius: 0 50px 50px 0;
          }
        }
        .tab-content {
          clear: both;
          width: 1300px;
          height: 516px;
          padding: 10px 26px 40px 26px;
          box-sizing: border-box;
          position: relative;
          .tab-btn {
            position: absolute;
            bottom: 100px;
            left: 130px;
            .btn{
              background: #085ECC;
              outline: none;
              border: none;
              &:hover{
                background: #4a98ff;
                transition-duration: 0.5s;
              }
            }
          }
        }
      }
    }
    .laval {
      width: 100%;
      height: 670px;
      text-align:center;
    }
    .logo-case {
      width: 100%;
      height: 668px;
      padding: 60px 0;
      box-sizing: border-box;
      div{
        width: 1200px;
        height: 580px;
        position: relative;
        margin: 0 auto;
        >img{
          width: 100%;
          height: 100%;
        }
        .case-btn {
          position: absolute;
          bottom: 120px;
          left: 100px;
          &:hover{
            background: #4a98ff;
            transition-duration: 0.5s;
            color: white;
          }
        }
      }
    }
    .swiper-container{
      position: relative;
      .wrapper {
        width: 100%;
        height: 550px;
        background: #eee;
        .per-img {
          width: 100%;
          height: 550px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
      >.swiper-pagination{
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .dia-title{
      .message {
        padding: 45px 130px;
        box-sizing: border-box;
        .message-inp {
          width: 380px;
          height: 40px;
        }
        .message-btn {
          width: 180px !important;
          height: 40px !important;
          margin-left: 28%;
          background: #085ECC;
          &:hover{
            background: #4a98ff;
            transition-duration: 0.5s;
          }
        }
      }
    }
  }
</style>
<style>
  .tourist-home > .laval > .el-carousel > .el-carousel__container {
    height: 670px;
  }

  .tourist-home > .laval > .el-carousel > .el-carousel__container > .el-carousel__arrow {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }
  .tourist-home > .dia-title > .el-dialog >.el-dialog__header{
    height: 70px;
    line-height: 70px;
    background: #f9f9f9;
  }
  .tourist-home > .dia-title > .el-dialog >.el-dialog__header > .el-dialog__title{
    color: #085ECC;
    font-size: 20px;
    font-weight: bold;
  }
</style>




// WEBPACK FOOTER //
// src/components/tourist/Home.vue